import { useMutation } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";

import { DeliveryCompany } from "../../deliveryCompanies.types";
import { requestCreateDeliveryCompany } from "./createDeliveryCompany.request";

const useCreateDeliveryCompany = (
  options?: MutationOptions<DeliveryCompany, ApiServiceError<ApiError>>
) => {
  return useMutation({
    mutationFn: requestCreateDeliveryCompany,
    ...options
  });
};

export default useCreateDeliveryCompany;
